import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`

@Injectable({
  providedIn: 'root'
})
export class WellSchematicService {

  constructor(private http: HttpClient) { }
  
  public getSvg(
    designId: string, 
    width: number, 
    height: number, 
    drawLabels: boolean = true, 
    drawReferenceLines: boolean = true,
    drawCurrentSection: boolean = false,
    tubularId: string | null = null
  ): Observable<string> {
    const params = new URLSearchParams({
      width: width.toString(),
      height: height.toString(),
      drawLabels: drawLabels.toString(),
      drawReferenceLines: drawReferenceLines.toString(),
      drawCurrentSection: drawCurrentSection.toString()
    });
    
    if (tubularId) {
      params.append('tubularId', tubularId);
    }
    
    return this.http.get(`${PeriforApiEndpoint}/WellSchematic/svg?designId=${designId}&${params.toString()}`, {
      responseType: 'text'
    }).pipe(
      catchError(() => of(null))
    );
  }
}
